var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-ss-c-filter-toggle",class:{
        'l-ss-c-filter-is-short': _vm.isShort,
        'l-ss-c-filter-toggle-is-checked': _vm.isChecked(_vm.option.id),
    },on:{"click":_vm.onToggle}},[_c('span',{staticClass:"l-ss-c-filter-toggle-icon"}),_c('c-label',{attrs:{"label":_vm.option.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }